import React from "react"
import PriceRange from "@bodeboca/algolia/components/filters/price-range"
import MenuFilter from "@bodeboca/algolia/components/filters/menu-filter"
import FiltersApplied
  from "@bodeboca/algolia/components/filters/filters-applied"
import RefinementFilter
  from "@bodeboca/algolia/components/filters/refinement-filter"
import HierachicalMenuFilter
  from "@bodeboca/algolia/components/filters/hierachical-menu-filter"
import ApiService from "@bodeboca/api"
import {useInstantSearch} from "react-instantsearch"

const Filters = () => {
  const filterComponents = []
  const filters = ApiService.getSearchFilters()
  for (let i = 0; i < filters.length; i++) {
    switch (filters[i].type) {
    case 'range' :
      filterComponents.push(<PriceRange  {...filters[i]} key={i}/>)
      break
    case 'refinement' :
      filterComponents.push(<RefinementFilter  {...filters[i]} key={i}/>)
      break
    case 'menu' :
      filterComponents.push(<MenuFilter  {...filters[i]} key={i}/>)
      break
    case 'hierachical' :
      filterComponents.push(<HierachicalMenuFilter  {...filters[i]} key={i}/>)
      break
    }
  }
  const {results} = useInstantSearch()
  const isHidden = () => {
    return results.hits.length === 0
  }

  return (<>
    <div
      className={isHidden() ? 'bb-product-filters display-none' : 'bb-product-filters'}>
      <div className="filter-by-prefix">
        <FiltersApplied/>
        <div className={"clear"}/>
        {filterComponents}
      </div>
    </div>
  </>)
}
export default Filters
